module.exports = __webpack_public_path__ + "img/selling_point_cover.3679d956.jpg";